import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors";

const styles = createUseStyles(theme => ({
  expiredGrid: {
    border: "none",
    borderTop: "1px solid" + colors.lightGrey,
    boxShadow: "none",
    borderRadius: 0,
    marginBottom: "-48px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0 -32px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "0 -16px -16px",
    },
    "& .rdt_TableCell": {
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      "& div": {
        color: colors.mediumGrey,
        fontWeight: 400,
        whiteSpace: "inherit !important"
      },
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCol": {
      color: colors.mediumGrey,
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      whiteSpace: "nowrap",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCol_Sortable": {
      overflow: "visible"
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px !important",
      marginRight: 0
    },
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: colors.lightBlack
  },
  nameWrapper: {
    display: "flex",
    minWidth: "100px",
  },
  initialsAvatar: {
    alignSelf: "center",
    width: "40px",
    height: "40px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "40px",
    fontSize: "16px",
    fontWeight: "500 !important",
    lineHeight: "24px",
    "& span": {
      color: colors.mediumGrey
    }
  },
  details: {
    marginLeft: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& p": {
      margin: 0,
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "& p:first-child": {
      color: colors.lightBlack,
      fontWeight: 500,
      lineHeight: "20px",
    },
    "& p:last-child": {
      color: colors.mediumGrey,
      fontWeight: 400,
      lineHeight: "20px",
    }
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "4px",
    cursor: "pointer",
    "& path": {
      stroke: colors.paleGrey,
    },
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "400px !important",
      padding: "8px 12px",
      fontSize: "12px",
      fontWeight: 600,
      textAlign: "left"
    }
  },
  unassigned: {
    fontStyle: "italic",
    color: `${colors.darkGrey} !important`,
    cursor: "not-allowed",
    paddingRight: "5px"
  },
  expiringSoon: {
    color: `${colors.warning600} !important`,
  }
}));

export default styles;
